module.exports = __webpack_public_path__ + "static/img/news_33.1cfd364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_33.png
// module id = SAn5
// module chunks = 2